module.exports = __webpack_public_path__ + "media/images/map-icons/carASelected@2x-1762bb78b79c158bf85eccba1ef779e4.png";